/* EU Custom Tax Toggle — Livia-Moda
   Load globally from theme.liquid:
   <script src="{{ 'eu-tax-toggle.js' | asset_url }}" defer></script>
   Place this file in: assets/eu-tax-toggle.js
*/
(function () {
  'use strict';

  if (window.__euTaxToggleInit) return;
  window.__euTaxToggleInit = true;

  var VARIANT_ID  = 54233826263367;
 var STORAGE_KEY = 'lm_eu_tax_enabled_v2';

  var nativeFetch = window.fetch.bind(window);

  function wantsEnabled() {
    var saved = localStorage.getItem(STORAGE_KEY);
    return saved === null ? false : saved === '1';
  }

  function cartPost(endpoint, body) {
    return nativeFetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart request failed: ' + res.status);
      return res.json();
    });
  }

  function getCart() {
    return nativeFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isTaxInCart(cart) {
    return cart.items.some(function (i) { return i.variant_id === VARIANT_ID; });
  }

  function addTax() {
    return cartPost('/cart/add.js', { items: [{ id: VARIANT_ID, quantity: 1 }] });
  }

  function removeTax() {
    return cartPost('/cart/update.js', { updates: (function () { var o = {}; o[VARIANT_ID] = 0; return o; })() });
  }

  function refreshDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function paintToggle() {
    var btn = document.getElementById('eu-tax-toggle-btn');
    if (!btn) return;
    var on = wantsEnabled();
    btn.setAttribute('aria-checked', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Wyłącz opłatę celną UE' : 'Dodaj opłatę celną UE');
  }

 function hasRealProduct(cart) {
    return cart.items.some(function (i) { return i.variant_id !== VARIANT_ID; });
  }

  var syncing = false;
  function syncCart() {
    if (syncing) return Promise.resolve();
    syncing = true;
    return getCart().then(function (cart) {
      var inCart = isTaxInCart(cart);
      var want = wantsEnabled();
      var hasProduct = hasRealProduct(cart);

      // Only add the tax when there's a real product AND the toggle is on
      if (want && hasProduct && !inCart) { return addTax().then(refreshDrawer); }
      // Remove the tax if the toggle is off, OR the cart has no real products
      if (inCart && (!want || !hasProduct)) { return removeTax().then(refreshDrawer); }
    }).then(paintToggle).catch(function (e) {
      console.warn('[EU Tax] sync error', e);
    }).then(function () { syncing = false; });
  }

  /* Toggle click — delegated so it survives drawer re-renders */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#eu-tax-toggle-btn');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var newState = !wantsEnabled();
    localStorage.setItem(STORAGE_KEY, newState ? '1' : '0');
    btn.classList.add('is-loading');
    paintToggle();

    var op = newState ? addTax() : removeTax();
    op.then(refreshDrawer).catch(function (err) {
      console.warn('[EU Tax] toggle error', err);
      localStorage.setItem(STORAGE_KEY, newState ? '0' : '1');
      paintToggle();
    }).then(function () { btn.classList.remove('is-loading'); });
  });

  /* Checkout interception */
  var proceeding = false;
  function ensureTaxThen(proceed) {
    if (!wantsEnabled()) { proceed(); return; }
    getCart().then(function (cart) {
      if (!isTaxInCart(cart)) return addTax();
    }).catch(function (e) {
      console.warn('[EU Tax] checkout ensure error', e);
    }).then(proceed);
  }

 document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = (form && form.getAttribute && form.getAttribute('action')) || '';
    var isCartForm = form && (form.id === 'cart-form' || action === '/cart' || action.indexOf('/checkout') !== -1);
    if (!isCartForm || proceeding || !wantsEnabled()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    proceeding = true;
    ensureTaxThen(function () { window.location.href = '/checkout'; });
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#checkout, [name="checkout"], .cart__checkout-button, a[href*="/checkout"]');
    if (!btn || proceeding || !wantsEnabled()) return;

    var form = btn.form || (btn.closest && btn.closest('form'));
    if (btn.type === 'submit' && form) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    proceeding = true;
    ensureTaxThen(function () {
      if (btn.tagName === 'A') window.location.href = btn.href;
      else if (form) form.submit();
      else window.location.href = '/checkout';
    });
  }, true);

  /* Detect ANY product add by wrapping fetch */
  window.fetch = function () {
    var args = arguments;
    var url = '';
    try { url = (args[0] && args[0].url) ? args[0].url : String(args[0] || ''); } catch (e) {}
    var promise = nativeFetch.apply(null, args);
    if (url.indexOf('/cart/add') !== -1) {
     promise.then(function () {
  setTimeout(syncCart, 400);
}).catch(function () {});
    }
    return promise;
  };

  /* Also wrap XMLHttpRequest in case the theme uses XHR for cart adds */
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__euUrl = url || '';
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__euUrl && xhr.__euUrl.indexOf('/cart/add') !== -1) {
      xhr.addEventListener('load', function () {
  setTimeout(syncCart, 400);
});
    }
    return origSend.apply(this, arguments);
  };

  function boot() {
    paintToggle();
    syncCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();